import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { parse } from 'query-string';
import { initFacebookSDK } from 'lib/facebook-sdk';
import { useMutation } from '@apollo/client';
// Api
import { FB_AUTH } from 'api/auth/mutations';
// Types
import { FbAuth, FbAuthVariables } from 'api/auth/types/FbAuth';
// Hooks
import { useDefferInitialization, useSocialAuth } from 'hooks';

const FacebookSdkWatcher = (): null => {
  const { handleSocialAuthResponse } = useSocialAuth();
  const { asPath } = useRouter();

  const ready = useDefferInitialization();

  const [fbAuth] = useMutation<FbAuth, FbAuthVariables>(FB_AUTH);

  const parsedUrl = parse(asPath);
  const facebookAccessToken = parsedUrl['/?#access_token'] as string;

  // if 'redirect' login (build-in browsers)
  useEffect(() => {
    if (facebookAccessToken) {
      const login = async (fbAccessToken: string): Promise<void> => {
        try {
          const { data } = await fbAuth({
            variables: { input: { accessToken: fbAccessToken } },
          });

          if (data?.fbAuth) {
            await handleSocialAuthResponse(data.fbAuth, {
              resetQueryWhenNoRedirect: false,
            });
          }
        } catch (error) {
          console.log('error', error);
        }
      };

      login(facebookAccessToken);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [facebookAccessToken]);

  useEffect(() => {
    const appId = process.env.NEXT_PUBLIC_FACEBOOK_APP_ID;

    /**
     * Load scripts with a delay to improve page speed
     * performance & a metrics score
     */
    if (appId && ready) {
      initFacebookSDK({
        appId,
      }).catch((error) => {
        console.log('initFacebookSDK', error);
      });
    }
  }, [ready]);

  return null;
};

export default FacebookSdkWatcher;
